import {AbstractControl} from '@angular/forms';

/*
 Validator for email value
 */
export class EmailValidator {

    static validate(c: AbstractControl) {
        let EMAIL_REGEXP = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        let isValid = c.value == null || c.value.length === 0 || EMAIL_REGEXP.test(c.value);
        return isValid ? null : {
            email: {
                valid: false
            }
        };
    }

}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/common/components/validation/validators/email.validator.ts